//librerias
import { Component, OnDestroy, OnInit } from "@angular/core";
//Servicios
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { SessionsService } from "src/app/services/session/sessions.service";

@Component({
  selector: "app-than-you-page",
  templateUrl: "./than-you-page.component.html",
  styleUrls: ["./than-you-page.component.css"],
})
export class ThanYouPageComponent implements OnInit, OnDestroy {
  fullName!: string | null;
  idcurso: any;
  numSession: any;
  nombrecurso!: string | null;
  masterQrData: { qrMaestro: boolean; totalPartesReales: number } | null = null;
  constructor(
    private sessionsService: SessionsService,
    private authLocal: AuthenticationService
  ) {}
  //Agregar validacion si no recibe los datos correctos redirigir a not found
  ngOnInit(): void {
    this.fullName =
      sessionStorage.getItem("TYnombre") !== undefined &&
      sessionStorage.getItem("TYnombre") !== null
        ? sessionStorage.getItem("TYnombre")
        : "";

    this.idcurso =
      sessionStorage.getItem("fkIdSesion") !== undefined &&
      sessionStorage.getItem("fkIdSesion") !== null
        ? sessionStorage.getItem("fkIdSesion")
        : "";
    const masterQrDataFromSession = sessionStorage.getItem("TYMasterQRData");
    this.masterQrData =
      masterQrDataFromSession !== undefined && masterQrDataFromSession !== null
        ? JSON.parse(masterQrDataFromSession)
        : null;

    this.numSession =
      sessionStorage.getItem("numeroSesion") !== undefined &&
      sessionStorage.getItem("numeroSesion") !== null
        ? sessionStorage.getItem("numeroSesion")
        : "";
    if (this.idcurso.length > 0) {
      this.sessionsService
        .getSessionBySessionId(this.idcurso)
        .subscribe(courseSession => {
          this.nombrecurso = courseSession.titulo;
        });
    }
    //Set user token when logged
    if (this.authLocal.currentUserValue?.email) {
      this.authLocal
        .loginToGetToken(this.authLocal.currentUserValue.email)
        .subscribe();
    } else {
      this.authLocal.clearUserData();
    }
  }

  ngOnDestroy() {
    sessionStorage.clear();
  }
}
